module.exports = __webpack_public_path__ + "static/media/logo-full.d71608c3.svg";